import en from './en.json'
import ru from './ru.json'
import zh from './zh.json'

export const messages = {
  en,
  ru,
  zh,
}

export const defaultLocale = 'ru'
export const availableLocales = Object.keys(messages)
